import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../api/axios";
import styles from "./Login.module.css";
import Logo from "./Logo";

function Login() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/auth/login", {
        email,
        password,
      });

      if (response.data.status) {
        const token = response.data.data.token;
        const userType = response.data.data.type;

        localStorage.setItem("token", token);
        localStorage.setItem("userType", userType);

        Swal.fire({
          title: t("login.success"),
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });

        if (userType === "admin") {
          navigate("/products");
        } else {
          navigate("/unauthorized");
        }
      } else {
        Swal.fire({
          icon: "error",
          title: "كلمة المرور غير صحيحة",
        });
      }
    } catch (error) {
      console.error("Login error:", error);
      Swal.fire({
        icon: "error",
        title: "كلمة المرور غير صحيحة",
      });
    }
  };

  return (
    <div
      dir="rtl"
      style={{
        minHeight: "100vh",
        backgroundImage: 'url("/images/bg.jpg")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#FDFBFC",
        position: "relative",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(253, 251, 252, 0.88)",
        }}
      />

      <div
        className="container position-relative d-flex justify-content-center align-items-center"
        style={{
          minHeight: "100vh",
          padding: "30px 15px",
        }}
      >
        <div
          className="w-100"
          style={{
            maxWidth: "460px",
          }}
        >
          <div
            className="text-center"
            style={{
              backgroundColor: "#FFFFFF",
              border: "1px solid #EEE5E8",
              borderRadius: "24px",
              padding: "35px 30px",
              boxShadow: "0 15px 50px rgba(181, 24, 63, 0.08)",
            }}
          >
            {/* Logo */}
            <div className="d-flex justify-content-center mb-4">
              <Logo />
            </div>

            {/* Icon / Title */}
            <div
              className="d-flex align-items-center justify-content-center mx-auto mb-3"
              style={{
                width: "55px",
                height: "55px",
                borderRadius: "16px",
                backgroundColor: "#F9E9EE",
                color: "#B5183F",
              }}
            >
              <i className="fa-solid fa-user-lock fs-5"></i>
            </div>

            <h2
              className="fw-bold mb-2"
              style={{
                color: "#272727",
                fontSize: "28px",
              }}
            >
              {t("login.title")}
            </h2>

            <p
              className="mb-4"
              style={{
                color: "#999999",
                fontSize: "14px",
              }}
            >
              {t("login.subtitle", "قم بتسجيل الدخول إلى حسابك")}
            </p>

            {/* Form */}
            <form onSubmit={handleLogin}>
              {/* Email */}
              <div
                className={styles.inputContainer}
                style={{
                  marginBottom: "16px",
                }}
              >
                <input
                  type="email"
                  className={styles.inputField}
                  placeholder={t("login.email_placeholder")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {/* Password */}
              <div
                className={styles.inputContainer}
                style={{
                  marginBottom: "20px",
                }}
              >
                <input
                  type="password"
                  className={styles.inputField}
                  placeholder={t("login.password_placeholder")}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              {/* Login Button */}
              <button
                className={styles.button}
                type="submit"
                style={{
                  width: "100%",
                  border: "none",
                  backgroundColor: "#B5183F",
                  color: "#FFFFFF",
                  borderRadius: "12px",
                  padding: "13px 20px",
                  fontWeight: "600",
                  fontSize: "15px",
                  transition: "all .2s ease",
                }}
              >
                {t("login.submit")}
              </button>

              {/* Forgot Password */}
              <div className="mt-4">
                <Link
                  to="/forgot-password"
                  className="text-decoration-none"
                  style={{
                    color: "#B5183F",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  نسيت كلمة السر؟
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
